var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD2D3A",
    d: "M7.303 14.713c.18.737-.223 2.456-.446 3.223c.819 0 2.773-.043 3.129-.232c.45-.227 1.569 0 2.014 0c.446 0 1.565-.458 2.015-.458c.445 0 1.564.69 1.787.921c.18.185.968.077 1.341 0v-4.144c0-.604-.223-1.153-.223-1.843s.223-1.153.223-1.843c0-.553-.15-3.763-.223-5.297l-.895 3.454v-.921c-.15.231-.446.784-.446 1.153c0 .458-.673 2.301-.896 2.764c-.18.369-.523 2.61-.668 3.686a2.2 2.2 0 0 1-.228-.78c0-.317 0-.836-.222-.836c-.223 0 .222-.921.222-1.38c0-.463 0-1.384.228-1.843c.222-.463-.45-2.074-.9-2.533c-.356-.368-.592-3.072-.669-4.375c-.073 1.153-.266 3.591-.446 4.144c-.223.69-.673 1.843-.673 2.301c0 .463-.222 1.616-.222 2.306c0 .553-.146 1.303-.223 1.612c-.3-.772-.896-2.443-.896-2.996s-.3-1.303-.446-1.612l-.223 1.153L7.753 5.04c-.077 1.843-.223 5.713-.223 6.45c0 .922-.45 2.302-.227 3.223m-.446 4.144v-.428h8.229c.403 0 .716.107.823.214c.086.086.857.034 1.234 0v.214c-.523-.034-1.663-.128-2.057-.214c-.493-.107-2.469.214-2.88.214s-1.44-.214-1.851-.214c-.33 0-2.469.141-3.498.214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimal);
export default __webpack_public_path__ + "static/media/primal.e0ac925d59e7e01749ff7512bc51679d.svg";
export { ForwardRef as ReactComponent };